import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import firebase from '../firebase';
import '../Pages/common.scss';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [actionCode, setActionCode] = useState('');
  
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    // Extract action code from URL query params
    const urlParams = new URLSearchParams(location.search);
    const oobCode = urlParams.get('oobCode');
    const mode = urlParams.get('mode');
    
    if (oobCode && mode === 'resetPassword') {
      setActionCode(oobCode);
    } else {
      setError('Invalid or expired reset link. Please request a new password reset.');
    }
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    
    if (password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }
    
    if (!actionCode) {
      setError('Invalid reset link');
      return;
    }
    
    try {
      setIsLoading(true);
      setError('');
      
      // Confirm the password reset with Firebase
      await firebase.auth().confirmPasswordReset(actionCode, password);
      
      setSuccess(true);
      setTimeout(() => {
        history.push('/signin');
      }, 3000);
      
    } catch (error) {
      console.error('Password reset error:', error);
      if (error.code === 'auth/invalid-action-code') {
        setError('This reset link has expired or is invalid. Please request a new one.');
      } else if (error.code === 'auth/weak-password') {
        setError('Password is too weak. Please choose a stronger password.');
      } else {
        setError('Failed to reset password. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-container">
        <div className="auth-box">
          <h2>Password Reset Successful!</h2>
          <p>Your password has been updated. You will be redirected to the sign-in page shortly.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Reset Your Password</h2>
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="password">New Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter new password"
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm new password"
              required
            />
          </div>
          
          <button 
            type="submit" 
            className="submit-btn"
            disabled={isLoading || !actionCode}
          >
            {isLoading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
        
        <div className="auth-links">
          <button 
            onClick={() => history.push('/signin')}
            className="link-btn"
          >
            Back to Sign In
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
